module.exports = __webpack_public_path__ + "img/247-house.a97b4597.png";